module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/personalize-runtime-2018-05-22.paginators.json
// module id = 745
// module chunks = 1